<template>
  <span 
    data-mdb-ripple-init
    ref="tooltipRef" 
    data-mdb-toggle="tooltip"
    :data-mdb-placement="placement"
    :title="text"
  >
    <slot></slot>
  </span>
</template>

<script setup>
import { ref, watch,onMounted, onUnmounted, computed, nextTick } from 'vue';

const props = defineProps({
  placement: {
    type: String,
    default: 'top'
  },
  customClass: {
    type: String,
    default: 'custom-tooltip'
  },
  toolTipInnerMaxWidth: {
    type: String,
    default: '300px'
  },
  text: {
    type: String,
    required: true
  },
// 参照mdb的tooltip的options https://mdbootstrap.com/docs/standard/components/tooltips/#docsTabsAPI
  options: {
    type: Object,
    default: () => ({
        container: 'body',
    })
  }
});

const tooltipRef = ref(null);
let tooltipInstance = null;
const innerMaxWidth = ref({
    width: '300px'
})
onMounted(() => {
  if (!tooltipRef.value || typeof mdb === 'undefined' || !mdb.Tooltip) {
    return;
  }

  nextTick(() => {
    tooltipRef.value.setAttribute('data-mdb-custom-class', props.customClass);
    
    tooltipInstance = new mdb.Tooltip(tooltipRef.value, {
      customClass: 'custom-tooltip ' + props.customClass,
      ...props.options
    })
  })
})

onUnmounted(() => {
  if (tooltipInstance && typeof tooltipInstance.dispose === 'function') {
    tooltipInstance.dispose();
  }
})
</script>

<style>
.custom-tooltip .tooltip-inner {
  display: block;
  margin: 0;
  padding: 0.5rem;
  max-width: 300px;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.125rem;
  text-align: left;
  background-color: #000;
  border-radius: 0.25rem;
  box-shadow: 0px 10px 32px 0px #00365b1a;
}
</style>